import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import { Row, Col } from '../../../utils/grid/Grid';

import './booking-form.css';

const BookingFormLayout = (props) => {
  const navigate = useNavigate();

  function onSubmit(data) {
    navigate(props.action, {
      state: {
        body: data,
      },
    });
  }

  return (
    <form to={props.action} className="booking-form" onSubmit={props.handleSubmit(onSubmit)}>
      <h2 className="booking-form-title">{props.title}</h2>
      {props.children}
      {props.fieldsets.map((fs, i) =>
        !fs.condition || fs.condition(props) ? (
          <fieldset key={i} className="booking-form-fieldset">
            <Row>
              <Col xs={12} md={3} className="booking-form-fieldset-legend" tagName="legend">
                {fs.legend}
              </Col>
              <Col xs={12} md={9} className="booking-form-fieldset-content">
                {_.isFunction(fs.content)
                  ? fs.content({ ...props, formControl: props.control })
                  : fs.content.map(({ label, field, condition, id, required }, j) => {
                      if (condition && !condition(props)) return null;
                      const labelClassName = classNames('booking-form-label', { required });
                      return (
                        <Row key={j}>
                          {_.isFunction(label) ? (
                            <Col xs={12} md={4} className={labelClassName}>
                              {label(props)}
                            </Col>
                          ) : (
                            <Col
                              xs={12}
                              md={4}
                              className={labelClassName}
                              tagName="label"
                              htmlFor={id}
                            >
                              {label}
                            </Col>
                          )}
                          <Col xs={12} md={8} className="booking-form-field">
                            {field({ ...props, formControl: props.control })}
                          </Col>
                        </Row>
                      );
                    })}
              </Col>
            </Row>
          </fieldset>
        ) : null,
      )}
    </form>
  );
};

BookingFormLayout.propTypes = {
  action: PropTypes.string.isRequired,
  title: PropTypes.string,
  children: PropTypes.node,
  fieldsets: PropTypes.arrayOf(
    PropTypes.shape({
      condition: PropTypes.func,
      legend: PropTypes.string,
      content: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.arrayOf(
          PropTypes.shape({
            condition: PropTypes.func,
            label: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
            field: PropTypes.func,
            required: PropTypes.bool,
            id: PropTypes.string,
          }),
        ),
      ]),
    }),
  ),
  handleSubmit: PropTypes.func.isRequired,
  control: PropTypes.object.isRequired,
};

export default BookingFormLayout;
